import { RouteConfig } from 'vue-router';

import { TableName } from '@/enums/tableName.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import Presences from '@/views/fee/Presences.vue';

export const teamFeePresencesRoute: RouteConfig = {
  path: 'feePresences',
  name: 'feePresences',
  component: Presences,
  meta: { title: 'titles.fee.presences' },
  beforeEnter: (to: any, from: any, next: any) => {
    const teamId = tryParseInt(to.params.teamId);

    store.commit('fee/presences/setFilters', { teamId });
    store.commit('fee/presences/setEntityType', TableName.Team);

    store
      .dispatch('team/player/list', { teamId })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.presenceFee.listError' }));
  }
};
